
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { authorizeUserServerSide } from 'api/firebaseAdmin';
import { createRedirectIfNeeded, Permalink } from 'helpers';
import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';
import { StaticPathParams } from 'typings/staticPaths';

const HowToWatch = (): JSX.Element => {
  return null;
};

 async function _getServerSideProps(
  ctx: GetServerSidePropsContext<StaticPathParams>,
): Promise<GetServerSidePropsResult<void>> {
  const { locale } = await authorizeUserServerSide(ctx);

  const redirect = createRedirectIfNeeded(ctx, locale);
  if (redirect) {
    return redirect;
  }

  return {
    redirect: {
      permanent: false,
      destination: Permalink.howToWatchWeb(locale),
    },
  };
}

export default HowToWatch;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/how-to-watch/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  